import * as Sentry from "@sentry/react";

let lastErrorMessage = "";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    // Pattern 1: {tenant}.{region}.trio.so
    /^https:\/\/[^.]+\.(us|eu)\.trio\.so/,
    // Pattern 2: {tenant}.trio-{env}.{region}.bcpapers.ca
    /^https:\/\/[^.]+\.trio-(stg|dev)\.(us|eu)\.bcpapers\.ca/,
  ],
  environment: import.meta.env.MODE,

  // Filter events before sending
  beforeSend(event) {
    const message = event.message || event.exception?.values?.[0]?.value || "";

    // Ignore duplicate consecutive errors
    if (message && message === lastErrorMessage) {
      return null;
    }

    // Example: ignore known noisy browser errors
    const ignoredErrors = [
      "ResizeObserver loop limit exceeded",
      "NetworkError when attempting to fetch resource",
    ];
    if (ignoredErrors.some((err) => message.includes(err))) {
      return null;
    }

    lastErrorMessage = message;
    return event;
  },

  // Optionally filter breadcrumbs to reduce noise
  beforeBreadcrumb(breadcrumb) {
    // Drop console logs or repetitive breadcrumbs
    if (breadcrumb.category === "console") {
      return null;
    }
    return breadcrumb;
  },
});
